import {
  Configuration,
  CourseInstanceApi,
  CreateCourseInstanceWithClassesRequest,
  CreateCourseInstanceWithClassesResponse,
} from "@masterschool/course-builder-api"
import { CampusClient } from "./campusClient"
import { selectAccessToken } from "@features/login/loginSelectors"
import { store } from "@app/store"

export enum CourseLanguage {
  English = "English",
  German = "German",
}

export type CourseInstanceDto = {
  id: string
  courseId: string
  majorVersion: number | undefined
  termId: string
}

export type CourseClassDto = {
  name: string
  id: string
  language: CourseLanguage
  courseInstanceId: string
  courseId: string
  majorVersion: number | undefined
  startDate: Date
  registeredStudentIds: string[]
}

export class CourseInstanceClient {
  private static courseInstanceApiClient = new CourseInstanceApi(
    new Configuration({
      basePath: `${import.meta.env.VITE_BASE_URL ?? ""}/api`,
    }),
  )

  private static makeHeaders() {
    return {
      headers: {
        Authorization: `Bearer ${selectAccessToken(store.getState())}`,
      },
    }
  }

  static async get(courseInstanceId: string): Promise<CourseInstanceDto> {
    return CampusClient.get<CourseInstanceDto>(
      `courseInstance/${courseInstanceId}`,
    )
  }

  static getByTerm(
    courseId: string,
    termId: string,
  ): Promise<CourseInstanceDto[]> {
    return CampusClient.get<CourseInstanceDto[]>(
      `courseInstance/termId/${termId}/courseId/${courseId}`,
    )
  }

  static async listCoursesHavingInstances(): Promise<string[]> {
    return CampusClient.get<string[]>(
      "courseInstance/list-courses-having-instances",
    )
  }

  static async listAllCourseInstances(): Promise<CourseInstanceDto[]> {
    return CampusClient.get<CourseInstanceDto[]>(
      "courseInstance/list-all-instances",
    )
  }

  static async listAllCourseClasses(): Promise<CourseClassDto[]> {
    return CampusClient.get<CourseClassDto[]>("courseInstance/list-all-classes")
  }

  static async setCourseInstanceMajorVersion(
    courseInstanceId: string,
    majorVersion: number,
  ): Promise<CourseInstanceDto> {
    return CampusClient.patch<CourseInstanceDto[]>(
      `courseInstance/update-major-versions`,
      [{ courseInstanceId, majorVersion }],
    ).then((courseInstances) => courseInstances[0])
  }

  static async instantiateCourseWithClasses(
    request: CreateCourseInstanceWithClassesRequest,
  ): Promise<CreateCourseInstanceWithClassesResponse> {
    return CourseInstanceClient.courseInstanceApiClient
      .courseInstanceControllerCreateLegacyCourse(
        request,
        CourseInstanceClient.makeHeaders(),
      )
      .then((response) => {
        return response.data
      })
  }
}
